import React from 'react';
import Link from 'next/link';
import { truncateText } from '@/app/funcs/funcs';

// Author Info Component
const AuthorInfo = ({ author }) => {
    if (!author) {
        return null;
    }

    const authorName = author.name || author.user_display_name || author.user_login || 'مستخدم غير معروف';
    const authorSlug = author.slug || author.user_login || author.name?.toLowerCase().replace(/\s+/g, '');
    const profileUrl = authorSlug ? `/@${authorSlug}` : '#';
    const AuthorAvatar = author?.acf?.avatar_id?.url ? author.acf?.avatar_id?.sizes?.thumbnail : (author?.avatar_urls ? author.avatar_urls[96] : null);

    return (
        <div className="d-flex align-items-center mt-2 rounded-5 p-2 w-fit border">
            {AuthorAvatar ? (
                <img 
                    src={AuthorAvatar} 
                    alt={authorName}
                    className="rounded-circle me-2"
                    width="24"
                    height="24"
                />
            ) : (
                <div className="bg-secondary rounded-circle me-2 d-flex align-items-center justify-content-center" style={{width: '24px', height: '24px'}}>
                    <i className="bi bi-person text-white" style={{fontSize: '12px'}}></i>
                </div>
            )}
            <Link href={profileUrl} className="text-decoration-none">
                <small className="text-dark fw-bold">{authorName}</small>
            </Link>
        </div>
    );
};

// Posts List Component
const PostsList = ({ 
    posts, 
    useInfiniteScroll, 
    lastPostRef, 
    realType,
    baseUrl = '/sections/articles' // Default URL, can be overridden
}) => (
    <ul className="list-group">
        {posts.map((item, index) => (
            <li
                key={item.id}
                className="list-group-item my-3 border-1 rounded-3 px-0 py-3"
                ref={useInfiniteScroll && index === posts.length - 1 ? lastPostRef : null}
                data-last-post={useInfiniteScroll && index === posts.length - 1 ? "true" : "false"}
            >
                <Link href={`${baseUrl}/${item.id}`}>
                    <div className="row mx-0">
                        {item.featured_image_urls && (
                            <div className="col-4 px-0 ps-md-3 bg-light">
                                <img
                                    src={item.featured_image_urls.medium}
                                    alt={item.title.rendered}
                                    className="img-fluid w-100 rounded"
                                />
                            </div>
                        )}
                        <div className="col-8 justify-content-between align-items-center pe-0">
                            <div className="d-flex flex-column h-100">
                                <div className="flex-grow-1">
                                    <b className="mb-2" dangerouslySetInnerHTML={{ __html: item.title.rendered }}>
                                        {/* {item.title.rendered} */}
                                    </b>
                                    <p className='fs-6 d-none d-md-block my-2' dangerouslySetInnerHTML={{ __html: truncateText(item.excerpt.rendered,200) }}></p>
                                    {/* {item.excerpt && (
                                        <p className="card-text text-muted mb-2">
                                            {truncateText(item.excerpt.rendered.replace(/<[^>]*>/g, ''), 150)}
                                        </p>
                                    )} */}
                                    <AuthorInfo author={item._embedded?.author?.[0]} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Link>
            </li>
        ))}
    </ul>
);

export default PostsList;
